var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScheduleIcon = function SvgScheduleIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#ECF1F3",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A657B",
    d: "M21.393 9.071h-2.115v-.535c0-.322-.214-.536-.536-.536-.32 0-.535.214-.535.536v.535h-5.414v-.535c0-.322-.214-.536-.535-.536-.322 0-.536.214-.536.536v.535H9.607C8.697 9.071 8 9.768 8 10.68v10.714C8 22.303 8.696 23 9.607 23h11.786c.91 0 1.607-.696 1.607-1.607V10.679c0-.911-.696-1.608-1.607-1.608zM9.607 10.143h2.115v.536c0 .321.214.535.536.535.32 0 .535-.214.535-.535v-.536h5.414v.536c0 .321.214.535.535.535.322 0 .536-.214.536-.535v-.536h2.115c.321 0 .536.214.536.536v1.607H9.07v-1.607c0-.322.215-.536.536-.536zm11.786 11.786H9.607c-.321 0-.536-.215-.536-.536v-8.036H21.93v8.036c0 .321-.215.536-.536.536z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-icon.041ef703823f0b49786fd1ff08a8de50.svg";